import luxPlusExperienceDiscountTakeoverConfig from 'takeovers/luxplusExperienceDiscountTakeover/luxPlusExperienceDiscountTakeoverConfig'
import maldivesCharterTakeoverConfig from 'takeovers/maldivesCharterTakeover/maldivesCharterTakeoverConfig'

import { TakeoverId } from '../client/lib/lab/dynamicPayload'
import societeDoublePointsTakeoverConfig from './societeDoublePointsTakeover/societeDoublePointsTakeoverConfig'

export { TakeoverId }

export const takeovers: Record<TakeoverId, App.SiteTakeoverConfig | undefined> = {
  // [TakeoverId.LUNAR_NEW_YEAR_TAKEOVER]: lunarNewYearTakeoverConfig,
  // [TakeoverId.VALENTINE_TAKEOVER]: valentineTakeoverConfig,
  // [TakeoverId.MARCH_TRAVEL_FRENZY_TAKEOVER]: marchTravelFrenzyTakeoverConfig,
  // [TakeoverId.TOUR_BEST_ASIA_PROMO_TAKEOVER]: tourBestAsiaPromoTakeoverConfig,
  // [TakeoverId.EASTER_TAKEOVER]: easterTakeoverConfig,
  // [TakeoverId.SOCIETY_TRIPLE_POINTS_TAKEOVER]: societyTriplePointsTakeoverConfig,
  // [TakeoverId.NEVER_ENDING_SUMMER_TAKEOVER]: neverEndingSummerTakeoverConfig,
  // [TakeoverId.LUX_PLUS_MONTH_TAKEOVER]: luxPlusMonthTakeoverConfig,
  [TakeoverId.MALDIVES_CHARTER_TAKEOVER]: maldivesCharterTakeoverConfig,
  [TakeoverId.DOUBlE_STATUS_CREDITS_TAKEOVER]: societeDoublePointsTakeoverConfig,
  [TakeoverId.LUX_PLUS_EXPERIENCE_DISCOUNT_TAKEOVER]: luxPlusExperienceDiscountTakeoverConfig,
  [TakeoverId.BEST_OF_2025_TAKEOVER]: undefined,
} as const
